import styled from 'styled-components';

export const RegistrationWrapper = styled.div`
  .new-group {
    margin-bottom: 34px;
  }
`;

export const InputsWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 34px;
  margin-bottom: 32px;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    align-items: start;
    gap: 16px;
  }
`;

export const Legend = styled.div`
  display: grid;
  grid-template-columns: 35% 15% 15% 1fr;
  gap: 10px;
  text-transform: uppercase;
  padding: 0 24px;
  margin-bottom: 10px;
  color: #515151;
`;

export const GroupCard = styled(Legend)`
  text-transform: none;
  color: unset;
  padding: 24px;
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);

  .btns-wrapper {
    justify-content: flex-end;
  }

  @media ${(props) => props.theme.device.mobileL} {
    grid-template-columns: 75px 1fr;
    padding: 16px 0;
    row-gap: 16px;
    box-shadow: none;
    border-bottom: 1px solid ${(props) => props.theme.colors.border};

    > h5:nth-child(odd) {
      text-transform: uppercase;
      color: #515151;
    }
    > *:nth-child(even) {
      text-align: right;
    }
  }
`;
